<template>
	<EventTeamLayout :event="event" :subtitle="trans('events.teams.scores.title')" :team-count="teamCount" :can-create="canCreate">
		<div class="w-full overflow-x-auto">
			<template v-if="!canCreate">
				<table v-for="(workshop, workshopIndex) in activities" :key="`workshop-${workshop.id}`" class="table-auto border-collapse">
					<thead>
						<tr>
							<th class="px-3 py-2 text-left" colspan="2">{{ workshop.title }}</th>
							<th class="px-3 py-2 w-[110px]">{{ trans('events.teams.scores.points') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(team, teamIndex) in workshop.teams" :key="`workshop-${workshop.id}-team-${team.id}`" class="bg-gray-100 dark:bg-gray-900">
							<td v-if="teamIndex + 1 === 1" class="px-3 py-2 border-y dark:border-gray-700 w-[50px] text-center font-bold">
								<i class="fa-solid fa-award text-amber-300"/>
							</td>
							<td v-else-if="teamIndex + 1 === 2" class="px-3 py-2 border-y dark:border-gray-700 w-[50px] text-center font-bold">
								<i class="fa-solid fa-award text-gray-500"/>
							</td>
							<td v-else-if="teamIndex + 1 === 3" class="px-3 py-2 border-y dark:border-gray-700 w-[50px] text-center font-bold">
								<i class="fa-solid fa-award text-amber-800"/>
							</td>
							<td v-else class="px-3 py-2 border-y dark:border-gray-700 w-[50px] text-center font-bold">{{ teamIndex + 1 }}</td>
							<td class="px-3 py-2 border-y dark:border-gray-700">{{ team.name }}</td>
							<td class="px-3 py-2 border-y dark:border-gray-700">
								<input v-model="team.pivot.score" type="number" min="0" max="100">
							</td>
						</tr>
					</tbody>
					<tfoot>
						<tr>
							<th class="px-3 py-2" colspan="2"/>
							<th class="px-3 py-2">
								<PrimaryButton :color="Color.Green" @click.stop="updateWorkshopScores(workshopIndex, workshop.id)">
									<i class="fa-solid fa-check"/>
								</PrimaryButton>
							</th>
						</tr>
					</tfoot>
				</table>
			</template>
		</div>
	</EventTeamLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import EventTeamLayout from '@/Layouts/EventTeamLayout.vue'
import {type Activity} from '@/Types/Events/Packs/Activities/Activity'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	event:Event,
	teamCount:number,
	canCreate:boolean,
	activities:Array<Activity>,
}>()

const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)
const canCreate:Ref<boolean> = ref(props.canCreate)
const activities:Ref<Array<Activity>> = ref(props.activities)

function updateWorkshopScores(workshopIndex:number, workshopId:number):void{
	if(!canCreate.value && !working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.teams.scores.update', {
			eventId: event.value.id,
			workshop: workshopId,
		}), {
			teams: activities.value[workshopIndex].teams,
		}).then(({data}) => {
			event.value = data
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>